import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import {
  getPDPDetails,
  notifyUser,
  getRandomSection,
} from 'hb-redux-store/feature/products/product.action';
import Button from 'components/common/Button/Button';

import ButtonCounter from 'components/common/Button/ButtonCounter';
import USP from 'components/web/USP/USP';
import Loader from 'components/mweb/Skeletons/Loader/Loader';
import { resetPDP } from 'hb-redux-store/feature/products/product.action';
import {
  postAddItem,
  postRemoveItem,
} from 'hb-redux-store/feature/cart/cart.action';
import { setAppNotification } from 'hb-redux-store/initial.action';
import Icon from 'components/mweb/Icon/Icon';
import { Helmet } from 'react-helmet';
import Footer from '../footer/index';
import PDPCarousel from '../../common/PDPCarousel/PDPCarousel';
import Modal from '../../mweb/Modal/Modal';
import { setPreorderModal } from 'hb-redux-store/feature/modal/modal.action';
import Reviews from '../../common/Reviews/Reviews';
import PdpAddons from '../../common/PdpAddons/PdpAddons';
import {
  getDiscountText,
  getPreorderText,
  getSelectedMultipleSkuIndex,
} from '../../../hb-redux-store/util/miscellaneousServices';
import HighLightTags from '../../mweb/HighlightTags/HighlightTags';
import StockLeft from '../../common/StockLeft/StockLeft';
import Deals from '../../web/Deals/Deals';
import MembershipBanner from 'components/mweb/MembershipBanner/MembershipBanner';
import MultipleSkuList from 'components/mweb/MultipleSku/MultipleSkuList';

const PRE_ORDER_ITEM = 'PRE ORDER ITEM';
const NON_PREORDER_ITEM = 'Express Delivery';
class PDP extends React.Component {
  constructor(props) {
    super(props);
    this.productId = this.props.productId;
    this.attrLimit = 3;
    this.state = {
      currentSku: null,
      topAttrs: null,
      opInProgress: false,
      showImageModal: false,
      activeSkuIndex: 0,
    };
  }

  checkOffset = () => {
    let scrollTop =
      window.pageYOffset ||
      (document.documentElement || document.body.parentNode || document.body)
        .scrollTop;
    const outerDivCondition =
        document.getElementsByClassName('desktop-pdp--column-left') &&
        document.getElementsByClassName('desktop-pdp--column-left')[0],
      innerDivCondition =
        document.getElementsByClassName('desktop-pdp--column-right') &&
        document.getElementsByClassName('desktop-pdp--column-right')[0] &&
        document.getElementsByClassName('desktop-pdp--column-right')[0]
          .firstChild;
    if (
      outerDivCondition &&
      document.getElementsByClassName('desktop-pdp--column-left')[0]
        .scrollHeight -
        scrollTop <=
        265
    ) {
      if (innerDivCondition) {
        const topHeight =
          document.getElementsByClassName('desktop-pdp--column-left')[0]
            .scrollHeight - 265;

        document.getElementsByClassName(
          'desktop-pdp--column-right'
        )[0].firstChild.style.position = 'absolute';
        //scroll after certain height
        document.getElementsByClassName(
          'desktop-pdp--column-right'
        )[0].firstChild.style.top = `${topHeight}px`;
      }
    } else if (innerDivCondition) {
      document.getElementsByClassName(
        'desktop-pdp--column-right'
      )[0].firstChild.style.position = 'fixed';
      document.getElementsByClassName(
        'desktop-pdp--column-right'
      )[0].firstChild.style.top = '';
    }
  };

  componentDidMount() {
    this.props.getPDPDetails(this.productId);
    this.props.getRandomSection({
      sectionSource: 'PDP',
      productId: this.productId,
    });
  }

  componentDidUpdate() {
    document.addEventListener('scroll', this.checkOffset);
  }

  // eslint-disable-next-line no-unused-vars
  shouldComponentUpdate(nextProps, nextState, nextContext) {
    if (!this.props.pdpDetails && nextProps.pdpDetails) {
      const skus = nextProps.pdpDetails.skus;
      const skuActiveIndex = getSelectedMultipleSkuIndex(
        nextProps.pdpDetails.skus
      );
      const currentSku = skus[skuActiveIndex];
      currentSku.discountText = getDiscountText({
        product: nextProps.pdpDetails,
        isProduct: true,
      });

      const topAttrs =
        currentSku?.skuAttributes?.filter(attr => attr.showTop) || [];
      this.setState({
        currentSku,
        topAttrs,
        skus,
        activeSkuIndex: skuActiveIndex,
      });
      return false;
    }
    return true;
  }

  componentWillUnmount() {
    this.props.resetPDP();
    document.removeEventListener('scroll', this.checkOffset);
  }

  successOpCb = msg => ({ sku: opSku, skuCount }) => {
    let sku = this.state.sku;
    const skus = this.state.skus.map(s => {
      if (opSku === s.sku) {
        s.inCartQuantity = skuCount;
        sku = s;
      }
      return s;
    });
    this.props.setAppNotification(msg);
    this.setState({ skus, sku, opInProgress: false });
  };
  failOpCb = msg => ({ errorMessage = msg }) => {
    if (errorMessage !== 'Please select a location.')
      this.props.setAppNotification(errorMessage);
    this.setState({ opInProgress: false });
  };

  addItem = () => {
    const { currentSku } = this.state;
    this.setState({ opInProgress: true }, () => {
      this.props.postAddItem({
        sku: currentSku?.sku,
        quantity: 1,
        productId: this.props.pdpDetails.productId,
        productName: this.props.pdpDetails?.productName,
        price: currentSku?.salePrice ?? currentSku?.retailPrice,
        source: 'PDP',
        successOpCb: this.successOpCb('Item added to cart'),
        failOpCb: this.failOpCb('Error adding item to cart'),
      });
    });
  };

  removeItem = () => {
    const { currentSku } = this.state;
    this.setState({ opInProgress: true }, () => {
      this.props.postRemoveItem({
        sku: currentSku?.sku,
        quantity: 1,
        productId: this.props.pdpDetails.productId,
        productName: this.props.pdpDetails?.productName,
        price: currentSku?.salePrice ?? currentSku?.retailPrice,
        source: 'PDP',
        successOpCb: this.successOpCb('Item removed from cart'),
        failOpCb: this.failOpCb('Error removing item to cart'),
      });
    });
  };
  zoomImage = () => this.setState({ showImageModal: true });
  notify = () => {
    this.props.notifyUser({ sku: this.state.currentSku?.sku });
  };

  getContent = sku => (
    <div className="justify-content--space-between desktop-pdp--main-details--presale-nudge">
      <div className="desktop-pdp--main-details--info-container">
        <Icon class="icon-pre-order" size={12} />
        <span className="desktop-pdp--main-details--pre-order-text">
          {!sku.isInventoryAvailable
            ? ''
            : sku.isPresale
            ? PRE_ORDER_ITEM
            : NON_PREORDER_ITEM}
        </span>
      </div>
      <span className="desktop-pdp--main-details--date-text">
        {getPreorderText(sku, 'PDP')}
      </span>
    </div>
  );

  updateMultipleSkuIndex = index => {
    const currentSku = this.props?.pdpDetails?.skus[index];
    const topAttrs =
      currentSku?.skuAttributes?.filter(attr => attr.showTop) || [];
    this.setState({
      activeSkuIndex: index,
      currentSku,
      topAttrs,
    });
  };

  render() {
    const {
      loadingPdp,
      pdpDetails,
      categorySeoName,
      randomSection,
    } = this.props;
    const { currentSku, topAttrs, showImageModal, activeSkuIndex } = this.state;
    const seo = {
      pageTitle: `Buy ${pdpDetails?.productName} ${categorySeoName} Online | Fresh Early Morning Delivery - VegXL`,
      keywords: `buy ${pdpDetails?.productName} ${categorySeoName} online`,
      canonicalUrl: `${window.location.origin}/${categorySeoName}/${this.props.productSeoName}`,
      pdpAltText: `Buy Fresh ${pdpDetails?.productName} online`,
      footerH1Text: `Buy Fresh ${pdpDetails?.productName} online`,
    };
    let primaryImage, images;
    if (pdpDetails) {
      primaryImage = pdpDetails.images.find(img => img.isPrimary).url;
      images = pdpDetails.images
        .filter(img => !img.isPrimary)
        .map(img => img.url);
      if (!images.length) images = [primaryImage];
      const seoMap = pdpDetails?.productSeoMapping || {};
      seo.pageTitle = seoMap.pageTitle || seo.pageTitle;
      seo.description = seoMap?.description || pdpDetails?.description;
      seo.keywords = seoMap?.keywords || seo?.keywords;
      seo.canonicalUrl = seoMap?.canonicalUrl || seo?.canonicalUrl;
      seo.pdpAltText = seoMap?.pdpAltText || seo?.pdpAltText;
    }
    return (
      <Fragment>
        <div className="desktop-pdp">
          {/* <SecondaryNav /> */}
          {loadingPdp && <Loader />}
          {!loadingPdp && pdpDetails && (
            <React.Fragment>
              <Helmet>
                <title>{seo.pageTitle}</title>
                <meta name="description" content={seo.description} />
                <meta name="keywords" content={seo.keywords} />
                <link rel="canonical" href={seo.canonicalUrl} />
                {/*  Twitter Card data  */}
                <meta name="twitter:card" value={seo.description} />
                {/*  Open Graph data  */}
                <meta property="og:title" content={seo.pageTitle} />
                <meta property="og:image" content={primaryImage} />
                <meta property="og:description" content={seo.description} />
              </Helmet>
              <div className="desktop-pdp--row">
                <div className="desktop-pdp--column desktop-pdp--column-left">
                  <div className="desktop-pdp--banner-image">
                    <PDPCarousel
                      images={images}
                      soldOut={!currentSku?.isInventoryAvailable}
                      desktop
                      altText={seo.pdpAltText}
                    />
                    {/*<ImageOverlay>*/}
                    {/*  <img*/}
                    {/*    src={primaryImage}*/}
                    {/*    className={*/}
                    {/*      !currentSku?.isInventoryAvailable ? 'sold-out' : ''*/}
                    {/*    }*/}
                    {/*    alt={pdpDetails.productName}*/}
                    {/*  />*/}
                    {/*</ImageOverlay>*/}
                    {!currentSku?.isInventoryAvailable && (
                      <div className="desktop-pdp--banner-image--sold-out-tag">
                        <span className="text">OUT OF STOCK</span>
                      </div>
                    )}
                    <div
                      className="desktop-pdp--banner-image--zoom-icon"
                      onClick={this.zoomImage}
                    >
                      <Icon class="icon-common-zoom-lens" size={50} />
                    </div>
                  </div>
                  <div className="desktop-pdp--description">
                    <div className="desktop-pdp--description--title">
                      Description
                    </div>
                    <div className="desktop-pdp--description--content">
                      {pdpDetails.description}
                    </div>
                    {randomSection && (
                      <Deals
                        products={randomSection.products}
                        title={randomSection.title}
                        showSoldOut={false}
                        source="PDP"
                      />
                    )}
                    <USP pageType={'ProductDescription'} />
                    <PdpAddons addons={pdpDetails.sections} desktop />
                  </div>
                </div>
                <div className="desktop-pdp--column desktop-pdp--column-right">
                  <div className="desktop-pdp--column-right-child ">
                    <MembershipBanner
                      containerStyle="desktop-pdp--membership-wrapper"
                      borderRadius
                      source="PDP"
                    />
                    <div
                      className={`desktop-pdp--main-details ${
                        pdpDetails.isBestSeller ? 'bestseller-tag' : ''
                      }`}
                    >
                      {pdpDetails.isBestSeller && (
                        <HighLightTags type="bestseller" source="pdp-desktop" />
                      )}
                      <ul className="desktop-pdp--main-details--ul justify-content--space-between">
                        <li className="desktop-pdp--main-details--li">
                          <div className="desktop-pdp--main-details--name">
                            {pdpDetails.productName}
                          </div>
                        </li>
                        <li className="desktop-pdp--main-details--li">
                          <span
                            className={`desktop-pdp--main-details--retail-price ${
                              currentSku?.onSale && currentSku?.salePrice > 0
                                ? 'on-sale'
                                : ''
                            }`}
                          >
                            &#8377;{currentSku?.retailPrice}
                          </span>
                          {currentSku?.onSale && currentSku?.salePrice > 0 && (
                            <span className="desktop-pdp--main-details--sale-price">
                              &#8377;{currentSku?.salePrice}
                            </span>
                          )}
                          {currentSku?.discountText && (
                            <span className="desktop-pdp--main-details--sale-tag">
                              <Icon size={18} class="icon-cart-on-sale" />
                              {currentSku?.discountText}
                            </span>
                          )}
                        </li>
                      </ul>
                      <div className="desktop-pdp--main-details--sku-list-container">
                        <MultipleSkuList
                          product={pdpDetails}
                          activeSkuIndex={activeSkuIndex}
                          setActiveSkuIndex={this.updateMultipleSkuIndex}
                        />
                      </div>
                      <ul className="desktop-pdp--main-details--ul justify-content--space-between">
                        <li className="desktop-pdp--main-details--li">
                          {/* <Dropdown /> */}
                        </li>
                        <li className="desktop-pdp--main-details--li">
                          <div>
                            {!currentSku?.isInventoryAvailable && (
                              <Button
                                className="button action-link desktop-pdp--main-details--notify-me cursor-hover"
                                onClick={this.notify}
                              >
                                Notify Me
                              </Button>
                            )}
                            {currentSku?.isInventoryAvailable &&
                              currentSku?.inCartQuantity === 0 && (
                                <Button
                                  className="button button-ghost"
                                  disabled={this.state.opInProgress}
                                  onClick={this.addItem}
                                >
                                  ADD
                                </Button>
                              )}
                            {currentSku?.isInventoryAvailable &&
                              currentSku?.inCartQuantity > 0 && (
                                <ButtonCounter
                                  onIncrement={this.addItem}
                                  onDecrement={this.removeItem}
                                  className="button-counter-ghost"
                                  counter={currentSku?.inCartQuantity}
                                  disabled={this.state.opInProgress}
                                />
                              )}
                          </div>
                        </li>
                      </ul>
                      {currentSku?.stockLeft && (
                        <StockLeft message={currentSku?.stockLeft} />
                      )}
                      {this.getContent(currentSku)}
                    </div>
                    <div className="desktop-pdp--top-attribute">
                      {(topAttrs || []).map((attr, index) => {
                        if (index < this.attrLimit) {
                          return (
                            <React.Fragment key={index}>
                              {index !== 0 && (
                                <div className="desktop-pdp--top-attribute--divider"></div>
                              )}
                              <div className="desktop-pdp--top-attribute--attr">
                                <div className="desktop-pdp--top-attribute--attr--key">
                                  {attr.displayName}
                                </div>
                                <div className="desktop-pdp--top-attribute--attr--value">
                                  {attr.value}
                                </div>
                              </div>
                            </React.Fragment>
                          );
                        }
                      })}
                    </div>
                  </div>
                </div>
              </div>
              {showImageModal && (
                <Modal
                  visible={showImageModal}
                  closable={false}
                  maskClosable={true}
                  wrapClassName="desktop-pdp--zoom-modal"
                  onCancel={() => this.setState({ showImageModal: false })}
                  maskStyle={{ background: 'rgba(0, 0, 0, 1)' }}
                >
                  <Icon
                    class="icon-common-close-white desktop-pdp--zoom-modal--close-icon"
                    size={30}
                    onClick={() => this.setState({ showImageModal: false })}
                  />
                  <PDPCarousel
                    desktop
                    images={images}
                    indicatorClassName="desktop-pdp--zoom-modal--indicator"
                    imageClassName="desktop-pdp--zoom-modal--fs-image"
                    altText={seo.pdpAltText}
                    // activeIndex={this.state.activeImageIndex}
                    // afterSwipe={i => this.setState({ activeImageIndex: i })}
                  />
                </Modal>
              )}
              <div className="section-divider" />
              <Reviews />
              <div>
                <Footer pdp h1={seo.footerH1Text} />
              </div>
            </React.Fragment>
          )}
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ productReducer }) => {
  const { loadingPdp, pdpDetails, randomSection } = productReducer;
  return {
    loadingPdp,
    pdpDetails,
    randomSection,
  };
};

const mapDispatchToProps = {
  getPDPDetails,
  resetPDP,
  postAddItem,
  postRemoveItem,
  setPreorderModal,
  setAppNotification,
  notifyUser,
  getRandomSection,
};

export default connect(mapStateToProps, mapDispatchToProps)(PDP);
